import { call, put, takeEvery } from 'redux-saga/effects'
import * as searchRequestActions from '../ducks/searchRequestDucks'
import * as searchRequestApi from '../../api/searchRequestApi'

interface FetchSearchRequestListSaga {
  type: string
  payload: string
}

interface FetchSearchRequestDetailSaga {
  type: string
  payload: string
}

function* fetchListSearchRequest({ payload: queryString }: FetchSearchRequestListSaga) {
  try {
    const res: ReturnType<typeof searchRequestApi.getListSearchRequest> = yield call(searchRequestApi.getListSearchRequest, queryString)
    yield put(searchRequestActions.getListSearchRequestSuccess(res))
  } catch (error) {
    yield put(searchRequestActions.getListSearchRequestFail(error))
  }
}

function* fetchDetailSearchRequest({ payload: id }: FetchSearchRequestDetailSaga) {
  try {
    const res: ReturnType<typeof searchRequestApi.getDetailSearchRequest> = yield call(searchRequestApi.getDetailSearchRequest, id)
    yield put(searchRequestActions.getDetailSearchRequestSuccess(res))
  } catch (error) {
    yield put(searchRequestActions.getDetailSearchRequestFail(error))
  }
}

export default function* watchSearchRequest() {
  yield takeEvery(searchRequestActions.getListSearchRequest.toString(), fetchListSearchRequest)
  yield takeEvery(searchRequestActions.getDetailSearchRequest.toString(), fetchDetailSearchRequest)
}
